import './toolbar.css'
import {
  Box,
  Flex,
  HStack,
  Link,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
  Text,
  Skeleton,
  Button,
  Icon,
  VStack,
  useColorModeValue
} from '@chakra-ui/react'
import { useEffect, useState, useMemo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
// import Select, { components } from 'react-select'
// import analyticsmobile from 'src/asset/images/analyticsmobile.svg'
// import levelIcon from 'src/asset/images/book.svg'
// import contentmarketing from 'src/asset/images/content-marketing.svg'
// import englishHindiIcon from 'src/asset/images/english-to-hindi.svg'
import dollar from 'src/asset/images/dollar-icon-png-3556.png'
// import hindi from 'src/asset/images/hindi2x.svg'
import generalLanguages from 'src/asset/images/Images/general-languages.png'
import logo from 'src/asset/images/logoBeta.svg'
import logoutmobile from 'src/asset/images/logoutmobile.svg'
// import marathi from 'src/asset/images/marathi.svg'
// import nepali from 'src/asset/images/nepali.png'
import notification from 'src/asset/images/notification-line.svg'
import manageSubscription from 'src/asset/images/manage-subscription.png'
import profile from 'src/asset/images/profileicon.svg'
import profilmobile from 'src/asset/images/profilmobile.svg'
// import analyticsIcon from 'src/asset/images/report.svg'
import { useAuth } from 'src/context/AuthContext'
import useSubscription from 'src/hooks/useSubscription'
import { useUser } from 'src/hooks/useUser'
import ImpersonateUser from 'src/ImpersonateUser'
import { noImageFoundText } from 'src/component/constants'
import {
  GetUnitWiseProgressCount,
  setSelectedLanguage,
  setSelectedLanguageId,
} from 'src/redux/actions'
// import { UIConfigHeader } from 'src/util/UIConfig'
import { getFileUrl, isMobile } from './CourseDetail/Practice/Util'
import { FaGlobe, FaChevronDown } from 'react-icons/fa';
import { MdOutlineExplore } from "react-icons/md";
import { FiMenu, FiX } from 'react-icons/fi';

// const LangIcon = {
//   Hindi: hindi,
//   Nepali: nepali,
//   Marathi: marathi,
//   'Content Marketing': contentmarketing,
//   'English - Hindi': englishHindiIcon,
// }

const iconHover = {
  color:
    'invert(30%) sepia(85%) saturate(3384%) hue-rotate(215deg) brightness(101%) contrast(92%)',
  filter:
    'invert(30%) sepia(85%) saturate(3384%) hue-rotate(215deg) brightness(101%) contrast(92%)',
}

const getInitials = username => {
  if (!username) return ''
  const spaceIndex = username.indexOf(' ')
  const firstLetter = username[0]?.toUpperCase()
  const secondLetter =
    spaceIndex > 0 ? username[spaceIndex + 1]?.toUpperCase() : ''
  return firstLetter + (secondLetter || '')
}

const getUserInfo = authInfo => {
  const username = authInfo?.username
  return {
    profileIconText: getInitials(username),
    username,
    email: authInfo?.email,
  }
}

const ProfileMenu = () => {
  const auth = useAuth()
  const { user } = useUser()
  const dispatch = useDispatch()
  const { isLoading, isSubscriptionActive, manageSubscrption } =
    useSubscription()
  const [showImpersonateUser, setShowImpersonateUser] = useState(false)
  const history = useHistory()

  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setIsOpen(false)
  }, [location.pathname])

  const { username, email, profileIconText } = getUserInfo(user)

  const handleNavigation = useCallback(
    path => () => {
      history.push(path)
    },
    [history]
  )

  const onLogoutClick = async () => {
    try {
      await auth.logout()
      dispatch(setSelectedLanguage(null))
      dispatch(setSelectedLanguageId(null))
      history.push('/login')
    } catch (err) {
      console.error(err)
    }
  }

  const renderName = () => username || email

  const menuItems = useMemo(
    () => [
      ...(isMobile
        ? [
          {
            label: 'Notifications',
            icon: notification,
            onClick: handleNavigation('/notification'),
          },
        ]
        : []),
      {
        label: 'Profile Settings',
        icon: profilmobile,
        onClick: handleNavigation('/userprofile'),
      },
      ...(user.role === 'ADMIN'
        ? [
          {
            label: 'Impersonate User',
            icon: profilmobile,
            onClick: () => setShowImpersonateUser(true),
          },
        ]
        : []),
      ...(!isLoading && isSubscriptionActive
        ? [
          {
            label: 'Manage Subscription',
            icon: manageSubscription,
            onClick: manageSubscrption,
          },
        ]
        : []),
      {
        label: 'Pricing',
        icon: dollar,
        onClick: handleNavigation('/pricing'),
        customRender: (
          <Link href="/pricing" _hover={{ textDecoration: 'none' }}>
            Pricing
          </Link>
        ),
      },
      {
        label: 'Logout',
        icon: logoutmobile,
        onClick: onLogoutClick,
      },
    ],
    [
      isMobile,
      user.role,
      isLoading,
      isSubscriptionActive,
      handleNavigation,
      manageSubscrption,
    ]
  )

  return (
    <>
      <Menu
        isOpen={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
      >
        <MenuButton
          as={IconButton}
          background="none"
          width="auto"
          aria-label="Profile"
          icon={<Image borderRadius="full" width="35px" src={profile} />}
        />
        <MenuList>
          <MenuGroup>
            <Flex
              alignItems="center"
              justifyContent="center"
              padding="8px 12.8px"
            >
              <Flex flex={0.2} alignItems="center">
                <Box
                  color="#FFFFFF"
                  bg="#000000"
                  width={8}
                  height={8}
                  borderRadius="50%"
                  padding="4px"
                  display="flex"
                  justifyContent="center"
                >
                  <Text>{profileIconText}</Text>
                </Box>
              </Flex>
              <Flex flex={0.8} flexDirection="column">
                <Text>{renderName()}</Text>
              </Flex>
            </Flex>
            {menuItems.map(item => (
              <MenuItem key={item.label} color="#2469F5" onClick={item.onClick}>
                <Image
                  boxSize={item.label === 'Pricing' ? '1.15rem' : '2rem'}
                  alt={noImageFoundText}
                  src={item.icon}
                  mr="12px"
                  width={4}
                  height={4}
                />
                {item.customRender || item.label}
              </MenuItem>
            ))}
          </MenuGroup>
        </MenuList>
      </Menu>
      {showImpersonateUser && (
        <ImpersonateUser
          isOpen={showImpersonateUser}
          setShowImpersonateUser={setShowImpersonateUser}
        />
      )}
    </>
  )
}

const LearnPageToolbar = () => {
  const selectedLesson = useSelector(store => store.mainReducer.selectedLesson)
  const history = useHistory()

  const onBacktoCourseClick = useCallback(() => {
    history.push(`/coursedetails/${selectedLesson?.extraInfo?.unitId}`)
  }, [history, selectedLesson])

  return (
    <Text
      onClick={onBacktoCourseClick}
      style={{
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }}
      cursor="pointer"
    >
      {`< Back to ${selectedLesson?.extraInfo?.unitName || ''}`}
    </Text>
  )
}

// const IconOption = props => {
//   const { data, isSelected } = props
//   return (
//     <components.Option {...props}>
//       <Box
//         className={`pointer ${isSelected ? 'selectedLanguage' : ''}`}
//         display="flex"
//         flexDirection="column"
//         justifyContent="center"
//         alignItems="center"
//       >
//         <img
//           src={data.langIcon ? getFileUrl(data.langIcon) : generalLanguages}
//           style={{
//             maxWidth: '32px',
//             marginBottom: '5px',
//             ...(!data.langIcon && { width: '32px' }),
//           }}
//           alt={data.label}
//         />
//         <Text fontSize="12px" textAlign="center">
//           {data.label}
//         </Text>
//       </Box>
//     </components.Option>
//   )
// }

// const languageStyle = {
//   option: base => ({
//     ...base,
//     justifyContent: 'center',
//     display: 'flex',
//   }),
//   control: base => ({
//     ...base,
//     height: 3,
//     minHeight: 3,
//     fontSize: 12,
//     marginTop: -16,
//     marginLeft: !isMobile ? 0 : 20,
//     width: !isMobile && '100%',
//   }),
//   menu: base => ({
//     ...base,
//     width: 'max-content',
//     minWidth: '100%',
//     left: 0,
//   }),
// }

// const getTheme = theme => ({
//   ...theme,
//   borderRadius: 0,
//   colors: {
//     ...theme.colors,
//     primary25: 'var(--chakra-colors-gray-200)',
//     primary: 'var(--chakra-colors-gray-200)',
//   },
// })

export default function Toolbar() {
  const history = useHistory()
  const dispatch = useDispatch()
  const location = useLocation()
  const { user } = useUser()

  const languages = useSelector(store => store.mainReducer.courses)
  const selectedLang = useSelector(store => store.mainReducer.selectedLanguage)
  const selectedLangId = useSelector(
    store => store.mainReducer.selectedLanguageId
  )

  const [toolbarLocation, setToolbarLocation] = useState('course')
  const [isLanguageLoaded, setIsLanguageLoaded] = useState(false)
  const [isLanguageValid, setIsLanguageValid] = useState(true)
  const [forceUpdate, setForceUpdate] = useState(false)
  const menuBg = useColorModeValue('white', 'gray.800');
  const menuHover = useColorModeValue('gray.100', 'gray.700');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        toggleMenu();
      }
    };
    if (isMenuOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  })

  const getLangIdFromPath = () => {
    const pathParts = window.location.pathname.split('/')
    return pathParts.includes('language')
      ? pathParts[pathParts.indexOf('language') + 1]
      : pathParts.includes('course')
        ? pathParts[pathParts.indexOf('course') + 1]
        : null
  }

  const selectedLanguage = useMemo(() => {
    try {
      const langIdFromPath = getLangIdFromPath()

      const languageFromPath = languages?.find(
        lang => lang?.id === langIdFromPath
      )

      if (langIdFromPath && !languageFromPath) {
        return null
      }

      let parsedLanguage = null
      try {
        const storedLanguage = localStorage.getItem('selectedLanguage')
        parsedLanguage = storedLanguage ? JSON.parse(storedLanguage) : null
      } catch (e) {
        console.error('Error parsing stored language:', e)
      }

      return (
        languageFromPath ||
        selectedLang ||
        (parsedLanguage &&
          languages?.some(lang => lang.id === parsedLanguage.id)
          ? parsedLanguage
          : null) ||
        languages?.[0]
      )
    } catch (e) {
      console.error('Error determining selected language:', e)
      return languages?.[0]
    }
  }, [languages, selectedLang, forceUpdate])

  const selectedLanguageId = useMemo(() => {
    const langIdFromPath = getLangIdFromPath()

    return (
      langIdFromPath ||
      selectedLangId ||
      localStorage.getItem('selectedLanguageId') ||
      languages?.[0]?.id
    )
  }, [languages, selectedLangId])


  const onLangSelectHandler = useCallback((lang) => {
    if (lang) {
      setIsMenuOpen(false);
      dispatch(setSelectedLanguage(lang))
      dispatch(setSelectedLanguageId(lang.id))
      localStorage.setItem('selectedLanguage', JSON.stringify(lang))
      localStorage.setItem('selectedLanguageId', lang.id)
      history.push(`/language/${lang.id}`)
    }
  }, [dispatch, history])

  useEffect(() => {
    if (languages && selectedLanguageId) {
      const currentLanguageValid = languages.some(
        lang => lang.id === selectedLanguageId
      )
      setIsLanguageValid(currentLanguageValid)

      if (!currentLanguageValid && languages.length > 0) {
        const firstValidLanguage = languages[0]
        if (firstValidLanguage) {
          dispatch(setSelectedLanguage(firstValidLanguage))
          dispatch(setSelectedLanguageId(firstValidLanguage.id))
          localStorage.setItem(
            'selectedLanguage',
            JSON.stringify(firstValidLanguage)
          )
          localStorage.setItem('selectedLanguageId', firstValidLanguage.id)

          window.location.href = `/language/${firstValidLanguage.id}`
        }
      }
    }
  }, [languages, selectedLanguageId, dispatch])

  useEffect(() => {
    if (!isLanguageValid && languages?.length) {
      setForceUpdate(prev => !prev)
    }
  }, [isLanguageValid, languages])

  useEffect(() => {
    if (languages) {
      dispatch(setSelectedLanguage(selectedLanguage))
      dispatch(setSelectedLanguageId(selectedLanguageId))
      setIsLanguageLoaded(true)
    }
  }, [languages, selectedLanguage, selectedLanguageId, dispatch])

  useEffect(() => {
    if (isMobile) {
      if (location.pathname.includes('/introduction/course/')) {
        setToolbarLocation('learn')
      } else if (location.pathname.includes('/course/')) {
        setToolbarLocation('practice')
      } else {
        setToolbarLocation('course')
      }
    }
  }, [location])

  useEffect(() => {
    if (selectedLanguageId) {
      dispatch(GetUnitWiseProgressCount(selectedLanguageId))
    }
  }, [selectedLanguageId, dispatch])

  const onLogoClick = useCallback(() => {
    history.push('/language')
  }, [history])

  const onNotificationClick = useCallback(() => {
    history.push('/notification')
  }, [history])

  // const onAnalyticsClick = useCallback(() => {
  //   history.push('/analytics')
  // }, [history])

  // const iconsList = useMemo(
  //   () => ({
  //     Learn: levelIcon,
  //     Analytics: analyticsIcon,
  //   }),
  //   []
  // )

  // const renderList = useCallback(() => {
  //   return Object.entries(UIConfigHeader.sideList).map(([key, value]) => {
  //     const isLearn = value === 'Learn'
  //     const handleClick = isLearn ? onLogoClick : onAnalyticsClick

  //     return (
  //       <ListItem
  //         key={key}
  //         padding={1}
  //         display="flex"
  //         flexDirection="column"
  //         alignItems="center"
  //         marginRight="30px"
  //         justifyContent="space-between"
  //         _hover={iconHover}
  //       >
  //         <Image
  //           src={iconsList[value]}
  //           alt={value}
  //           cursor="pointer"
  //           onClick={handleClick}
  //           style={{
  //             width: isLearn ? '26px' : '20px',
  //             marginLeft: isLearn ? '20px' : '0px',
  //             marginTop: isLearn ? '10px' : '-5px',
  //             marginBottom: isLearn ? '3px' : '-5px',
  //           }}
  //         />
  //         <Text
  //           fontSize="12"
  //           ml={isLearn ? '20px' : '0px'}
  //           onClick={handleClick}
  //         >
  //           {value}
  //         </Text>
  //       </ListItem>
  //     )
  //   })
  // }, [iconsList, onAnalyticsClick, onLogoClick])


  if (!user || window.location.href.includes('/home')) {
    return null
  }

  if (toolbarLocation === 'practice') {
    return null
  }

  if (!isLanguageValid && languages?.length) {
    return (
      <Box width="100%" height="60px" bg="white">
        <Skeleton height="100%" />
      </Box>
    )
  }

  return (
    <>
      <HStack
        key={`toolbar-${forceUpdate}`}
        px="18px"
        py="35px"
        position="sticky"
        zIndex="111111"
        width="100%"
        height="60px"
        background="#fff"
        top={0}
        border="1px solid #d8d8d8"
        boxShadow="3px 2px 3px 0px rgb(167 167 167 / 20%)"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        {toolbarLocation === 'course' ? (
          <>
            <Box cursor="pointer" zIndex="9999" display="flex" justifyContent="start" alignItems="center" gap="1rem">
              {/* company logo */}
              <Image
                onClick={onLogoClick}
                src={logo}
                alt={noImageFoundText}
                sx={{
                  objectFit: 'contain',
                  height: { base: '40px', md: '50px', lg: '65px' },
                  width: { base: '100px', md: '130px', lg: '150px' },
                  marginTop: '10px',
                }}
              />
              <Box display={{ base: 'none', md: 'block' }}>
                <Box display="flex" justifyContent="start" alignItems="center" gap="1rem">
                  {/* Language select button */}
                  <Flex flex="1" justify="center">
                    <Menu autoSelect={false}>
                      {isLanguageLoaded ? <MenuButton
                        as={Button}
                        rightIcon={<Icon as={FaChevronDown} color="black" w={4} h={4} marginInlineStart="3px" />}
                        py={2}
                        h="44px"
                        _hover={{ bgGradient: 'linear(to-r, blue.50, indigo.50)' }}
                        borderRadius="lg"
                        width="auto"
                        _focus={{ boxShadow: 'none' }}
                        _active={{ boxShadow: 'none' }}
                        iconSpacing={0}
                      >
                        <Flex align="center" gap={1}>
                          {/* <Icon as={FaGlobe} w={8} h={8} color="blue.600" /> */}
                          <img
                            src={selectedLanguage?.langIcon ? getFileUrl(selectedLanguage?.langIcon) : generalLanguages}
                            style={{
                              width: '28px',
                              height: "auto"
                            }}
                            alt={selectedLanguage?.label}
                          />
                          <Text fontSize="sm" color="#2469F5">
                            {selectedLanguage?.label}
                          </Text>
                        </Flex>
                      </MenuButton> : <Skeleton width="100px" height="32px" />}
                      <MenuList
                        bg={menuBg}
                        border="1px solid"
                        borderColor="gray.200"
                        boxShadow="xl"
                        rounded="xl"
                        px={2}
                        py={2}
                        zIndex="60"
                      >
                        {languages?.map((language, index) => (
                          <MenuItem
                            key={index}
                            onClick={() => onLangSelectHandler(language)}
                            bg={selectedLanguage?.id === language.id ? 'blue.50' : 'transparent'}
                            color={selectedLanguage?.id === language.id ? 'blue.700' : 'gray.700'}
                            rounded="lg"
                            px={3}
                            py={2.5}
                            my={1}
                            transition="all 0.2s"
                            _hover={{ bg: menuHover }}
                          >
                            <Flex align="center" w="full">
                              <Box display="flex" justifyContent="flex-start" alignItems="center" gap="5px">
                                <img
                                  src={language?.langIcon ? getFileUrl(language?.langIcon) : generalLanguages}
                                  style={{
                                    width: '32px',
                                    height: "auto"
                                  }}
                                  alt={language.label}
                                />
                                <Text fontSize="14px" textAlign="center" marginLeft="8px">
                                  {language?.label}
                                </Text>
                              </Box>
                              {selectedLanguage?.id === language?.id && (
                                <Box ml="auto" w={2} h={2} bg="blue.500" borderRadius="full" animation="pulse" />
                              )}
                            </Flex>
                          </MenuItem>
                        ))}
                      </MenuList>
                    </Menu>
                  </Flex>

                  {/* <Box className="language-dropdown">
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
            >
              <img
                src={
                  selectedLanguage?.langIcon
                    ? getFileUrl(selectedLanguage.langIcon)
                    : generalLanguages
                }
                alt={selectedLanguage?.course}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  marginLeft: 55,
                  zIndex: 99,
                  marginBottom: 10,
                }}
              />
              {isLanguageLoaded ? (
                <Select
                  mr="auto"
                  onChange={onLangChange}
                  className="langSelect"
                  options={languages}
                  styles={languageStyle}
                  isSearchable={false}
                  value={selectedLanguage}
                  components={{ Option: IconOption }}
                  theme={getTheme}
                  aria-label="Language selection"
                />
              ) : (
                <Skeleton width="100px" height="32px" />
              )}
            </Box>
            <Box>
              <List
                py="2"
                spacing={3}
                cursor="pointer"
                display="flex"
                flexDirection="row"
              >
                {!isMobile && renderList()}
              </List>
            </Box>
                 </Box> */}

                  {/* Explore button */}
                  <Box
                    display="flex"
                    justifyContent="start"
                    alignItems="center"
                    gap="3px"
                    px={4}
                    py={2}
                    rounded="md"
                    _hover={{ backgroundColor: '#E2E8F0' }}
                  >
                    <MdOutlineExplore size={22} color={"#2469F5"} />
                    <Text
                      onClick={() => history.push('/explore')}
                      onMouseEnter={() => import('../Container/Explore')}
                      style={{
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        color: location?.pathname === "/explore" ? "#2469F5" : "black",
                        fontWeight: 500
                      }}
                      cursor="pointer"
                    >
                      Explore
                    </Text>
                  </Box>
                </Box>
              </ Box>
            </Box>
            <HStack gap={3}>
              {/* {!isMobile && ( */}
              <Image
                width="35px"
                alt={noImageFoundText}
                src={notification}
                _hover={iconHover}
                style={{ cursor: 'pointer' }}
                onClick={onNotificationClick}
              />
              {/* )} */}
              <ProfileMenu />
              {/* Toggle button for responsive menu list */}
              <Box display={{ base: 'block', md: 'none' }}>
                <IconButton
                  onClick={toggleMenu}
                  aria-label="Open main menu"
                  width="auto"
                  icon={
                    <Box position="relative" w={6} h={6}>
                      <Box
                        as={FiMenu}
                        boxSize={6}
                        position="absolute"
                        inset="0"
                        transition="all 0.3s"
                        opacity={isMenuOpen ? 0 : 1}
                        transform={isMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
                      />
                      <Box
                        as={FiX}
                        boxSize={6}
                        position="absolute"
                        inset="0"
                        transition="all 0.3s"
                        opacity={isMenuOpen ? 1 : 0}
                        transform={isMenuOpen ? 'rotate(0deg)' : 'rotate(-180deg)'}
                      />
                    </Box>
                  }
                  variant="ghost"
                  color="gray.700"
                  _hover={{ color: 'blue.600', bg: 'gray.100' }}
                  _focus={{ boxShadow: 'outline', ring: 2, ringColor: 'blue.500' }}
                  sx={{ boxShadow: 'outline', ring: 2, ringColor: 'blue.500' }}
                />
              </Box>
            </HStack>
          </>
        ) : (
          <LearnPageToolbar />
        )}
      </HStack>

      {/* Mobile Menu Panel */}
      <Box
        display={{ base: 'block', md: 'none' }}
        position="fixed"
        top="64px"
        left="0"
        right="0"
        bg="white"
        shadow="xl"
        zIndex="overlay"
        transform={isMenuOpen ? 'translateY(0)' : 'translateY(-16px)'}
        opacity={isMenuOpen ? 1 : 0}
        transition="all 0.3s ease-out"
        pointerEvents={isMenuOpen ? 'auto' : 'none'}
        minHeight="100vh"
        overflow="auto"
        w="100%"
      >
        <VStack px={4} py={6} spacing={2} align="stretch" w="100%">
          <Box w="100%" display="flex" flexDirection="column" justifyContent="start" alignItems="start" gap="1rem">
            {/* Language select button */}
            <Flex w="100%" justify="center">
              <Box w="100%">
                <Menu autoSelect={false} w="100%">
                  {isLanguageLoaded ? (
                    <MenuButton
                      as={Button}
                      rightIcon={<Icon as={FaChevronDown} color="#2469F5" w={4} h={4} marginInlineStart="3px" />}
                      py={2}
                      h="44px"
                      _hover={{ bgGradient: 'linear(to-r, blue.50, indigo.50)' }}
                      borderRadius="lg"
                      w="100%"
                      _focus={{ boxShadow: 'none' }}
                      _active={{ boxShadow: 'none' }}
                      iconSpacing={0}
                    >
                      <Flex align="center" gap={1}>
                        <img
                          src={selectedLanguage?.langIcon ? getFileUrl(selectedLanguage?.langIcon) : generalLanguages}
                          style={{ width: '28px', height: "auto" }}
                          alt={selectedLanguage?.label}
                        />
                        <Text fontSize="sm" color="gray.700">
                          {selectedLanguage?.label}
                        </Text>
                      </Flex>
                    </MenuButton>
                  ) : (
                    <Skeleton width="100px" height="32px" />
                  )}
                  <MenuList
                    bg={menuBg}
                    border="1px solid"
                    borderColor="gray.200"
                    boxShadow="xl"
                    rounded="xl"
                    px={2}
                    py={2}
                    zIndex="60"
                    minW="unset"
                    maxW="unset"
                    className="menu-item-list"
                  >
                    {languages?.map((language, index) => (
                      <MenuItem
                        key={index}
                        w="full"
                        onClick={() => onLangSelectHandler(language)}
                        bg={selectedLanguage?.id === language.id ? 'blue.50' : 'transparent'}
                        color={selectedLanguage?.id === language.id ? 'blue.700' : 'gray.700'}
                        rounded="lg"
                        px={3}
                        py={2.5}
                        my={1}
                        transition="all 0.2s"
                        _hover={{ bg: menuHover }}
                      >
                        <Flex align="center" w="full">
                          <Box display="flex" alignItems="center" gap="5px">
                            <img
                              src={language?.langIcon ? getFileUrl(language?.langIcon) : generalLanguages}
                              style={{ width: '32px', height: 'auto' }}
                              alt={language.label}
                            />
                            <Text fontSize="14px" marginLeft="8px">
                              {language?.label}
                            </Text>
                          </Box>
                          {selectedLanguage?.id === language?.id && (
                            <Box ml="auto" w={2} h={2} bg="blue.500" borderRadius="full" animation="pulse" />
                          )}
                        </Flex>
                      </MenuItem>
                    ))}
                  </MenuList>
                </Menu>
              </Box>
            </Flex>

            {/* Explore button */}
            <Box
              display="flex"
              justifyContent="start"
              alignItems="center"
              gap="3px"
              px={4}
              py={2}
              rounded="md"
              backgroundColor="#E2E8F0"
              width="100%"
              onClick={() => { setIsMenuOpen(false); history.push('/explore') }}
              onMouseEnter={() => import('../Container/Explore')}
            >
              <MdOutlineExplore size={22} color={"#2469F5"} />
              <Text
                style={{
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  color: location?.pathname === "/explore" ? "#2469F5" : "black",
                  fontWeight: 500
                }}
                cursor="pointer"
              >
                Explore
              </Text>
            </Box>
          </Box>
        </VStack>
      </Box>

    </>
  )
}